import React from 'react';
import { NavbarBrand } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';
import {
  PageNotFoundContainer,
  PageNotFoundNavBar,
} from './PageNotFound.style';
import IMAGES from '../../../constants/Images';
import PlaceholderImage from '../../PlaceholderImage/PlaceholderImage';
import { whiteLabelEnabled } from '../../../constants/AppConstants';

export default function PageNotFound() {
  const { companyLogo, companyLogoStyle } = useSelector(
    state => ({
      companyLogo: state.whitelabelCompanyData.companyLogo,
      companyLogoStyle: state.whitelabelCompanyData.companyLogoStyle,
    }),
    shallowEqual
  );

  return (
    <PageNotFoundContainer>
      <PageNotFoundNavBar className="cursor-pointer">
        <NavbarBrand className="ml-3 cursor-pointer">
          <PlaceholderImage
            src={companyLogo}
            alt="DoSelect"
            style={companyLogoStyle}
            placeholderHeight={whiteLabelEnabled ? '50px' : '30px'}
            placeholderWidth={whiteLabelEnabled ? '384px' : '148px'}
          />
        </NavbarBrand>
      </PageNotFoundNavBar>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6 col-12">
            <img src={IMAGES.DOSELECT_BAD_BOT_LOGO} alt="" />
          </div>
          <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6 col-12">
            <div className="title">Couldn&apos;t find it. . .</div>
            <div className="sub-title">
              I tried to find the page that you&apos;re looking for, but looks
              like <strong>it&apos;s been removed</strong> or{' '}
              <strong>you did a typo</strong>. But of course, it&apos;s my
              fault. Sorry.
              <br />
              <br />
              Oh, and the status code is 404, BTW.
            </div>
          </div>
        </div>
      </div>
    </PageNotFoundContainer>
  );
}
